import React, { useCallback, useState } from 'react';
import { useLatest, useUnmount } from 'ahooks';
import { HelpInPhysiotherapyStage, Toast, TrackerCustomEvent, useTracker } from 'common-package';
import { Icon } from '@fuxi/eevee-icon';
import { useSelector } from 'react-redux';
import { selectCurrentServingOrder } from '@/store/service';
import cx from './index.module.scss';

interface Props {
  currentProcess: HelpPhysiotherapyStage;
  showTitle?: boolean;
  className?: string;
  //如果是服务过程中 可不传以下参数
  goodsId?: number;
  orderId?: number; //下单前orderId为空
}

type FeedbackState = 'NoHelp' | 'HasHelp' | 'NotClick';

enum SuggestionsForFeedbackText {
  'NotClick' = '未点击',
  'NoHelp' = '点踩',
  'HasHelp' = '点赞',
}

const SuggestionsForFeedback: React.FC<Props> = ({ showTitle = true, currentProcess, goodsId = null, className }) => {
  const [selectState, setSelectState] = useState<FeedbackState>('NotClick');
  const { sendEvent } = useTracker();
  const currentServingOrder = useSelector(selectCurrentServingOrder);

  const latestCountRef = useLatest(selectState);

  useUnmount(() => {
    if (!!currentServingOrder?.storeGoodsId && !!currentProcess && latestCountRef.current !== 'NotClick') {
      sendEvent(TrackerCustomEvent.SuggestionsForFeedback, {
        et: 'CLK',
        c1: currentServingOrder?.goodsId || goodsId,
        c2: currentServingOrder?.orderId,
        c3: HelpInPhysiotherapyStage[currentProcess],
        c4: SuggestionsForFeedbackText[latestCountRef.current],
      });
    }
  });

  const handleSelectState = useCallback(
    (clickState: FeedbackState) => {
      if (selectState === 'NotClick') {
        setSelectState(clickState);
        Toast.show('感谢您的反馈', { duration: 3000 });
      } else if (selectState === 'HasHelp') {
        if (clickState === 'HasHelp') {
          setSelectState('NotClick');
        } else {
          setSelectState('NoHelp');
          Toast.show('感谢您的反馈', { duration: 3000 });
        }
      } else if (selectState === 'NoHelp') {
        if (clickState === 'NoHelp') {
          setSelectState('NotClick');
        } else {
          setSelectState('HasHelp');
          Toast.show('感谢您的反馈', { duration: 3000 });
        }
      }
    },
    [selectState]
  );

  return (
    <div className={cx('wrapper', className)}>
      {showTitle && <div className={cx('title', 'custom-title')}>本页内容是否有帮助</div>}
      <div className={cx('select-wrapper')}>
        <div className={cx('has-help', 'custom-help-item')} onClick={() => handleSelectState('HasHelp')}>
          <Icon
            name={selectState === 'HasHelp' ? 'has-help-selected' : 'has-help'}
            className={cx('icon', { selected: selectState === 'HasHelp' }, 'custom-help-icon')}
          />
          <span className={cx('text', 'custom-help-text')}>有帮助</span>
        </div>
        <div className={cx('no-help', 'custom-help-item')} onClick={() => handleSelectState('NoHelp')}>
          <Icon
            name={selectState === 'NoHelp' ? 'no-help-selected' : 'no-help'}
            className={cx('icon', { selected: selectState === 'NoHelp' })}
          />
          <span className={cx('text', 'custom-help-text')}>没帮助</span>
        </div>
      </div>
    </div>
  );
};

export default SuggestionsForFeedback;
